import React, {useState, Fragment, useEffect} from 'react';
import { nuevoOActualizarRegistroPersonalizado, nuevoOActualizarRegistroPersonalizadoConMetodo, obtenerRegistrosPorURL } from 'store/actions/customAction';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import TituloConImagen from 'components/tituloConImagen';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { Card, CardContent, Grid } from '@mui/material';
import TituloConIcono from 'components/tituloConIcono';
import { NavigateNext, Visibility } from '@mui/icons-material';
import { TablaPersonalizada } from 'components';
import Formulario from 'components/formulario';
import { useHistory } from 'react-router-dom';
import {useDispatch} from 'react-redux';
import { NoAutorizado } from 'commons';
import ModalDeImagen from 'components/ImageModal';
import { tipoDeMedio } from 'constantes/globalsStates';
import { functions } from 'constantes';
import { declaracionesJuradas } from 'constantes/declaracionesjuradas';

let idEjecutivoMedios = "";
let datosDeEmpresaGlobal = {}

const DatosDeEmpresa = ({header, tituloGeneral, icon, tituloDeTabla, addRegister, nombreToolTip, iconTabla, setDatosDeEmpresa, controladorTarifario, recargarLaTabla, datosDeEmpresa, setRecargarLaTabla, tipoMedio}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const[base64Imagen, setBase64Imagen] = useState("");
    const[mostrarLogo, setMostrarLogo] = useState(false);
    const[ControladorInformacionYDatosDeEmpresa] = useState("informacionYDatosDeEmpresaController");
    const [validarDatos, setValidarDatos] = useState({checkearAutorizacion: false, autorizado: true, cargando: true});
    datosDeEmpresaGlobal = datosDeEmpresa;

    const verificarPorNitSiExisteEmpresa = (event) => { if (event.key==="Enter") validarSiTienePermiso(camposDelFormulario.nit.value) }

    const validarSiTienePermiso = async (nit) => {
        setcargandoSolicitud(true);
        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: "seguridadDeFormularios", saveInStore: false, action: "tienePermiso", nombreDelMetodo: "tienePermiso", parametro: tipoDeMedio[tipoMedio]}));

        setcargandoSolicitud(false);

        if(!respuesta?.data) return alertaPersonalizadaSwal( 'No tiene permisos para este formulario')
        consultarAPI(nit);
    }

    const consultarAPI = async (nit) => {
        setcargandoSolicitud(true);
        const copiaDeCampos = Object.assign({}, camposDelFormulario);

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: ControladorInformacionYDatosDeEmpresa, saveInStore: false, nombreDelMetodo: "listar", parametro: nit}));

        setcargandoSolicitud(false);

        buttonList.saveData.label = "Guardar datos";
        copiaDeCampos.logo.validators.required = true;
        copiaDeCampos.logo.disabledVisualization = false;

        if(respuesta?.error || respuesta?.data?.length === 0) {
            cambiarValoresACampos("nombreEmpresa", false)
            cambiarValoresACampos("razonSocial", false)
            cambiarValoresACampos("NombrePublico", false)
            cambiarValoresACampos("telefono", false)
            cambiarValoresACampos("logo", false)
            cambiarValoresACampos("cui", false, "")
            cambiarValoresACampos("nombreCompleto", false, "")
            cambiarValoresACampos("celular", false, "")
            cambiarValoresACampos("correoElectronico", false, "")
            cambiarValoresACampos("descripcionDelMedio", false, "")
            return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });
        }
        const {nombreComercial, razonSocial, nombreEmpresa, telefono, logo, personas} = respuesta.data;
        cambiarValoresACampos("nombreEmpresa", true, nombreEmpresa?.trim() || "")
        cambiarValoresACampos("razonSocial", true, razonSocial?.trim() || "")
        cambiarValoresACampos("NombrePublico", true, nombreComercial?.trim() || "")
        cambiarValoresACampos("telefono", true, telefono || "")
        cambiarValoresACampos("logo", false, logo || "")
        cambiarValoresACampos("nit", true, nit)

        let ejecutivoDeMedios = {};
        if(personas?.length > 0 ) {
            const ejecutivoDeMediosEncontrado = personas.find( ({tipoDePersona_id}) => Number(tipoDePersona_id) === 5)
            ejecutivoDeMedios = ejecutivoDeMediosEncontrado;
            if(ejecutivoDeMediosEncontrado) {
                buttonList.saveData.label = "Editar datos";
                const {cui, nombre, telefono, correoElectronico, descripcion} = ejecutivoDeMediosEncontrado;
                cambiarValoresACampos("cui", false, cui)
                cambiarValoresACampos("nombreCompleto", false, nombre)
                cambiarValoresACampos("celular", false, telefono)
                cambiarValoresACampos("correoElectronico", false, correoElectronico)
                cambiarValoresACampos("descripcionDelMedio", false, descripcion)
                cambiarValoresACampos("logo", false, logo)
                copiaDeCampos.logo.validators.required = false;
                copiaDeCampos.logo.disabledVisualization = true;
                idEjecutivoMedios = cui;
            } else {
                cambiarValoresACampos("cui", false, "")
                cambiarValoresACampos("nombreCompleto", false, "")
                cambiarValoresACampos("celular", false, "")
                cambiarValoresACampos("correoElectronico", false, "")
                cambiarValoresACampos("descripcionDelMedio", false, "")
                idEjecutivoMedios = "";
            }
        }
        setDatosDeEmpresa({...respuesta.data, ejecutivoDeMedios, nit})
        setCamposDelFormulario(copiaDeCampos);
        obtenerRegistrosDeTarifarios(nit)
    }

    useEffect( () => {
        if(recargarLaTabla) obtenerRegistrosDeTarifarios(datosDeEmpresa.nit)
    }, [recargarLaTabla])

    const obtenerRegistrosDeTarifarios = async (nit) => {
        try{
            setValidarDatos({checkearAutorizacion: true, autorizado: false, cargando: true});
            setcargandoSolicitud(true);

            const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controladorTarifario,'listar');
            if (hasPermission.error) return setValidarDatos({checkearAutorizacion: false, autorizado: false,cargando: false});

                ServiciosDelAPI[controladorTarifario].iniciarMetodoDeBusqueda.clear();
                ServiciosDelAPI[controladorTarifario].iniciarMetodoDeBusqueda.addEquals('empresa.nit', nit);
                ServiciosDelAPI[controladorTarifario].iniciarMetodoDeOrden.clear();
                ServiciosDelAPI[controladorTarifario].iniciarMetodoDeOrden.addDesc("fechaCreacion");
                setcargandoSolicitud(false);
                setValidarDatos({checkearAutorizacion: false, autorizado: true,cargando: false});
                setRecargarLaTabla(false)
        }catch(exception){
            alertaPersonalizadaSwal( exception.message || 'No encontramos información. Intente recargar de nuevo.')
            setValidarDatos({checkearAutorizacion: false, autorizado: true,cargando: false});
        }
    }

    const cambiarValoresACampos = (campo, disabled, value = "") => {
        camposDelFormulario[campo].disabled = disabled;
        camposDelFormulario[campo].value = value;
    }

    const obtenerLogo = async () => {
        setcargandoSolicitud(true);

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: ControladorInformacionYDatosDeEmpresa, saveInStore: false, nombreDelMetodo: "obtenerImagenDeEmpresa", parametro: datosDeEmpresaGlobal?.nit}));

        setcargandoSolicitud(false);

        if(respuesta?.error) return changeDataResponse('error', respuesta?.error?.message || "No encontramos información del documento", true)

        if(!respuesta?.data ) return changeDataResponse('error', "No encontramos información del documento", true)

        setBase64Imagen(respuesta.data)
        setMostrarLogo(true)
    }

    const cerrarModalDeImagen = () => setMostrarLogo(false)

    const [camposDelFormulario, setCamposDelFormulario] = React.useState({
        titleBusquedaNit:{
            idelement: "titleBusquedaNit", title:'Buscar empresa por nit', position:"center", elementType:'titulo', showTitleForm: true, name: "titleBusquedaNit", value: "", isError:false,
        },
        nit: {
            idelement: "nit", value: "", label: "Ingrese Nit y de enter", pattern:"^([0-9]{1,})+([a-zA-Z]{1})?$", validators: ['required'], errorMessages:['El campo nit es requerido'], isError:false, elementType:'texto', name:"nit", 'disabled': false, keyPress: verificarPorNitSiExisteEmpresa, width: "90%", autofocus: true
        },
        titleObservacion:{
            idelement: "titleObservacion", title:'Datos de la empresa', position:"center", elementType:'titulo', showTitleForm: true, name: "titleObservacion", value: "", isError:false,
        },
        nombreEmpresa: {
            idelement: "nombreEmpresa",  value: "", label: "Nombre de la empresa", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"nombreEmpresa", 'disabled': true, width: "33%",
        },
        razonSocial: {
            idelement: "razonSocial",  value: "", label: "Razón Social / Propietario", pattern:"^[a-zA-Z0-9ñÑä-üÀ-ÿ -.Çç,/&()´]+$", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"razonSocial", 'disabled': true, width: "33%",
        },
        telefono: {
            idelement: "telefono",  value: "", label: "Telefono", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"telefono", 'disabled': true, width: "33%",
        },
        NombrePublico: {
            idelement: "NombrePublico",  value: "", label: "Nombre con el que le conoce el público", pattern:"", validators: ['required'], errorMessages:[''], isError:false, elementType:'texto', name:"NombrePublico", 'disabled': true, width: "50%",
        },
        logo:{
            idelement: "logo", value: "", label: "LOGO (Máximo 5 MB)",
            validators: {required: true, size: "5 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled': true, name:"logo", fileWidth: true, src: '', multiple: false, accept:".png, .jpg", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "Logo Empresa", iconButton: <Visibility />, handleVisualization: obtenerLogo,  fileType: "png"
        },
        titleContactoMedio:{
            idelement: "titleContactoMedio", title:'Contacto ejecutivo de medios', position:"center", elementType:'titulo', showTitleForm: true,  name: "titleContactoMedio", value: "", isError:false,
        },
        cui:{
            idelement: "cui", value: "", label: "Ingrese CUI del DPI", pattern:"^[0-9]{13}$", validators: ['required'],
            errorMessages:['Numérico de 13 digitos'], isError:false, elementType:'texto','disabled':false, autofocus: false, keyPress: undefined, maxLength: 13, name:"cui", width: "50%",
        },
        nombreCompleto: {
            idelement: "nombreCompleto",  value: "", label: "Nombre de ejecutivo de medios *", pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”]{4,70}$", validators: ['required'], errorMessages:['El campo es requerido sin espacios al final'], isError:false, elementType:'texto', name:"nombreCompleto", 'disabled': false, width: "50%",
        },
        celular: {
            idelement: "celular", value: "", label: "Teléfono de contacto*", pattern:"^[0-9]{8}$", validators: ['required'], errorMessages:['Numérico de 8 digitos'], isError:false, elementType:'texto', name:"celular", autofocus: false, width: "50%", maxLength: 8,
        },
        correoElectronico: {
            idelement: "correoElectronico", value: "", label: "Correo electrónico *", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,4}$", validators: ['required'], errorMessages:['Ingrese un correo válido'], isError:false, elementType:'texto', name:"correoElectronico", width: "50%",
        },
        descripcionDelMedio:{
            idelement: "descripcionDelMedio", value: "", label: `Descripción del medio`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,300}$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "descripcionDelMedio", width: '100%'
        },
        acciones:{
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const cancelAction = () => history.goBack('/')

    const guardarDatos = async (dataForm) => {
        setcargandoSolicitud(true);

        const { cui, nombreCompleto, celular, correoElectronico, descripcionDelMedio, logo, nit } = dataForm;

        const datosAGuardar = {
            ejecutivoDeMediosRequest: { celular: Number(celular), correoElectronico, cui: Number(cui), descripcionDelMedio, nombreCompleto},
            empresaRequest: { logo },
            nitEmpresa: nit
        };
        let datosAEnviar = {};
        let respuesta = {};
        const nombreDelMetodo = "actualizarRegistroDeEmpresaYRegistroDeEjecutivoDeMedios";

        if(idEjecutivoMedios) {
            datosAGuardar.idEjecutivoMedios = idEjecutivoMedios
            datosAEnviar = { controller: ControladorInformacionYDatosDeEmpresa, action: "editarEjecutivoDeMedios", data: {...datosAGuardar.ejecutivoDeMediosRequest, logo: logo || null}, nombreDelMetodo: `editarEjecutivoDeMedios/${datosDeEmpresaGlobal?.nit}/${datosDeEmpresaGlobal?.ejecutivoDeMedios?.cui}` };
            respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        } else {
            datosAEnviar = { controller: ControladorInformacionYDatosDeEmpresa, action: nombreDelMetodo, data: datosAGuardar, nombreDelMetodo };
            respuesta = await dispatch(nuevoOActualizarRegistroPersonalizadoConMetodo(datosAEnviar));
        }

        setcargandoSolicitud(false);
        if(respuesta?.error) return alertaPersonalizadaSwal(respuesta?.error?.message || "No se puedo guardar los datos, intente nuevamente!",'')

        alertaPersonalizadaSwal(respuesta?.data?.message || "Datos guardados correctamente", "", "success")
        if(!idEjecutivoMedios) consultarAPI(datosDeEmpresaGlobal?.nit)
    }

    const [buttonList]= React.useState({
        "saveData":{"label":  "Guardar Datos", "icon": <NavigateNext />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelAction":{"label":"Salir", "icon": <NavigateNext />,"callback":cancelAction,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const descargarDeclaracionJuradaIndividual = () => {
        switch(tipoDeMedio[tipoMedio]){
            case 1: // TELEVISION
                functions.descargarBase64EnPDF(declaracionesJuradas.personaIndividualTvRadio, "declaracion_jurada_persona_individual_television.docx")
                break;
            case 2: // RADIO
                functions.descargarBase64EnPDF(declaracionesJuradas.personaIndividualTvRadio, "declaracion_jurada_persona_individual_radio.docx")
                break;
            case 3: // escritos
                functions.descargarBase64EnPDF(declaracionesJuradas.personaIndividualVallasPantallas, "declaracion_jurada_persona_individual_escritos.docx")
                break;
            case 4: // pantallas
                functions.descargarBase64EnPDF(declaracionesJuradas.personaIndividualVallasPantallas, "declaracion_jurada_persona_individual_pantallas.docx")
                break;
            case 5: // vallasFijas
                functions.descargarBase64EnPDF(declaracionesJuradas.personaIndividualVallasPantallas, "declaracion_jurada_persona_individual_vallas_fijas.docx")
                break;
            case 6: // vallasMoviles
                functions.descargarBase64EnPDF(declaracionesJuradas.personaIndividualVallasPantallas, "declaracion_jurada_persona_individual_vallas_moviles.docx")
                break;
            default:
                break;
        }
    }

    const descargarDeclaracionJuradaJuridica = () => {
        switch(tipoDeMedio[tipoMedio]){
            case 1: // TELEVISION
                functions.descargarBase64EnPDF(declaracionesJuradas.personaJuridicaTvRadio, "declaracion_jurada_persona_juridica_television.docx")
                break;
            case 2: // RADIO
                functions.descargarBase64EnPDF(declaracionesJuradas.personaJuridicaTvRadio, "declaracion_jurada_persona_juridica_radio.docx")
                break;
            case 3: // escritos
                functions.descargarBase64EnPDF(declaracionesJuradas.personaJuridicaVallasPantallas, "declaracion_jurada_persona_juridica_escritos.docx")
                break;
            case 4: // pantallas
                functions.descargarBase64EnPDF(declaracionesJuradas.personaJuridicaVallasPantallas, "declaracion_jurada_persona_juridica_pantallas.docx")
                break;
            case 5: // vallasFijas
                functions.descargarBase64EnPDF(declaracionesJuradas.personaJuridicaVallasPantallas, "declaracion_jurada_persona_juridica_vallas_fijas.docx")
                break;
            case 6: // vallasMoviles
                functions.descargarBase64EnPDF(declaracionesJuradas.personaJuridicaVallasPantallas, "declaracion_jurada_persona_juridica_vallas_moviles.docx")
                break;
            default:
                break;
        }
    }

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta,})

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;
    const {checkearAutorizacion, autorizado, cargando} = validarDatos;

    if (checkearAutorizacion ) return <IndicadorDeCarga open={cargando}/>
    if (!autorizado && !cargando){ return <NoAutorizado />}

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
            <TituloConIcono
                title={tituloGeneral}
                titleButton1="Descargar declaración jurada (Persona Individual)" titleButton2="Descargar declaración jurada (Persona Jurídica)"
                handleClickButton1={descargarDeclaracionJuradaIndividual}
                handleClickButton2={descargarDeclaracionJuradaJuridica}
                icon={icon}
                widthIcon="90px" heighIcont="80px"
            />
            <Card>
                <CardContent>
                    <Grid container>
                        <Grid item xs={12} sm={6} >
                            <Formulario
                                elements={camposDelFormulario}
                                buttonList={buttonList}
                            />
                        </Grid>
                        {(autorizado && !cargando ) && (
                            <Grid item xs={12} sm={6} >
                                <TituloConImagen title={tituloDeTabla} icon={iconTabla} />
                                <TablaPersonalizada
                                    service={ServiciosDelAPI[controladorTarifario]}
                                    data={[]}
                                    title={""}
                                    header={header}
                                    refreshList={ undefined}
                                    addRegister={addRegister}
                                    nameToolTipAdd={nombreToolTip}
                                />
                            </Grid>
                        )}
                    </Grid>
                </CardContent>
            </Card>
            {mostrarLogo && (
                <ModalDeImagen base64={base64Imagen} title={"Logo de la empresa"} open={mostrarLogo} handleClose={cerrarModalDeImagen} showDownloadButton={false} src={base64Imagen} />
            )}
        </Fragment>
    );
}

export default DatosDeEmpresa;